var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        "div",
        { staticClass: "contract-wrap" },
        [
          _c("ValidationObserver", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "font-size": "1.5em",
                          "font-weight": "bold",
                        },
                      },
                      [
                        _vm._v(" 年員工薪資所得受領人免稅額申報表 "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "0.8em !important",
                              float: "right",
                            },
                          },
                          [
                            _vm._v(
                              " 員工編號:" + _vm._s(_vm.incomeTax.EmployeeNo)
                            ),
                          ]
                        ),
                        _c("hr"),
                      ]
                    ),
                    _c("div", [
                      _c("table", { staticClass: "basic-info-table" }, [
                        _c("tr", [
                          _c("th"),
                          _c("th", { staticStyle: { width: "25%" } }, [
                            _vm._v("姓名"),
                          ]),
                          _c("th", { staticStyle: { width: "25%" } }, [
                            _vm._v("出生年月日"),
                          ]),
                          _c("th", { staticStyle: { width: "25%" } }, [
                            _vm._v("國民身分證統一編號或統一證號"),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "10%",
                                "font-weight": "bold",
                              },
                            },
                            [_vm._v("薪資受領人")]
                          ),
                          _c("td", [_vm._v(_vm._s(_vm.incomeTax.Name))]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.$common.dateFormatter(
                                  _vm.incomeTax.Birthday
                                )
                              )
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(_vm.incomeTax.IdNo))]),
                        ]),
                        _c("tr", [
                          _c("td", { staticStyle: { "font-weight": "bold" } }, [
                            _vm._v("配偶"),
                          ]),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                staticClass: "w-100",
                                attrs: {
                                  name: "配偶姓名",
                                  rules: _vm.required ? "required" : null,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("el-input", {
                                            model: {
                                              value: _vm.incomeTax.SpouseName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.incomeTax,
                                                  "SpouseName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "incomeTax.SpouseName",
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                staticClass: "w-100",
                                attrs: {
                                  name: "出生年月日",
                                  rules: _vm.required ? "required" : null,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("el-date-picker", {
                                            staticClass: "w-100",
                                            attrs: {
                                              type: "date",
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options": {
                                                disabledDate:
                                                  _vm.$common
                                                    .disabledDateAfterToday,
                                              },
                                              placeholder: "YYYY-MM-DD",
                                            },
                                            model: {
                                              value:
                                                _vm.incomeTax.SpouseBirthday,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.incomeTax,
                                                  "SpouseBirthday",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "incomeTax.SpouseBirthday",
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                staticClass: "w-100",
                                attrs: {
                                  name: "配偶國民身分證統一編號或統一證號",
                                  rules: _vm.required ? "required" : null,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("el-input", {
                                            model: {
                                              value: _vm.incomeTax.SpouseIdNo,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.incomeTax,
                                                  "SpouseIdNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "incomeTax.SpouseIdNo",
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", { staticStyle: { "font-weight": "bold" } }, [
                            _vm._v("通訊地址"),
                          ]),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm._v(" " + _vm._s(_vm.incomeTax.Address) + " "),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "mt-2" }, [
                      _vm._v(
                        " 合於減除扶養親屬免稅額之受扶養親屬（共計 " +
                          _vm._s(_vm.total) +
                          " 人） "
                      ),
                    ]),
                    _c("ul", { staticClass: "title" }, [
                      _c("li", { staticClass: "mt-2" }, [
                        _vm._v(
                          " 依法得稅法第 17 條規定，納稅義務人及其配偶之直系尊親屬合於下列條件之一者，每年每人得減除其扶養親屬免稅額。 "
                        ),
                        _c("ul", { staticClass: "subtitle" }, [
                          _c("li", [_vm._v("(1) 年滿 60 歲；")]),
                          _c("li", [
                            _vm._v(
                              "(2) 未滿 60 歲，但無謀生能力受納稅義務人扶養。"
                            ),
                          ]),
                          _c("li", [
                            _vm._v(
                              " 本人及配偶之直系尊親屬合於上列規定條件者，計有 " +
                                _vm._s(
                                  _vm.incomeTax.Parents
                                    ? _vm.incomeTax.Parents.length
                                    : 0
                                ) +
                                " 人 "
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { "min-width": "100%" },
                              attrs: {
                                data: _vm.incomeTax.Parents,
                                border: "",
                              },
                            },
                            [
                              _vm.incomeTax.Parents &&
                              _vm.incomeTax.Parents.length > 0
                                ? _c("el-table-column", {
                                    attrs: { width: "42" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("eva-icon", {
                                                attrs: {
                                                  name: "minus-square-outline",
                                                  fill: "#606266",
                                                  width: "20",
                                                  height: "20",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delRow(
                                                      "parents",
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _c(
                                "el-table-column",
                                {
                                  attrs: { width: "220" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("ValidationProvider", {
                                              staticClass: "w-100",
                                              attrs: {
                                                name: `姓名+parents+${scope.$index}`,
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("el-input", {
                                                          model: {
                                                            value:
                                                              scope.row.Name,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "Name",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.Name",
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "header" },
                                    [
                                      _vm._v(" 姓名 "),
                                      _c("eva-icon", {
                                        attrs: {
                                          name: "plus-square-outline",
                                          fill: "#606266",
                                          width: "20",
                                          height: "20",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRow("parents")
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c("el-table-column", {
                                attrs: { label: "稱謂", width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `稱謂+parents+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .Relationship,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "Relationship",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.Relationship",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "出生年月日", width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `出生年月日+parents+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-date-picker", {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          type: "date",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          "picker-options": {
                                                            disabledDate:
                                                              _vm.$common
                                                                .disabledDateAfterToday,
                                                          },
                                                          placeholder:
                                                            "YYYY-MM-DD",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.Birthday,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "Birthday",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.Birthday",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "國民身分證統一編號或統一證號",
                                  width: "300",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `國民身分證統一編號或統一證號+parents+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-input", {
                                                        model: {
                                                          value: scope.row.IdNo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "IdNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.IdNo",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "符合之條件" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `符合之條件+parents+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.Type,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "Type",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.Type",
                                                          },
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "直系尊親屬滿60",
                                                              value: 1,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "直系尊親屬未滿60",
                                                              value: 2,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女未成年",
                                                              value: 3,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年在學",
                                                              value: 4,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年身心障礙",
                                                              value: 5,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年無謀生能力",
                                                              value: 6,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹未成年",
                                                              value: 7,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年在學",
                                                              value: 8,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年身心障礙",
                                                              value: 9,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年無謀生能力",
                                                              value: 10,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬未成年",
                                                              value: 11,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年在學",
                                                              value: 12,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年身心障礙",
                                                              value: 13,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年無謀生能力",
                                                              value: 14,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("li", { staticClass: "mt-2" }, [
                        _vm._v(
                          " 依法得稅法第 17 條規定，納稅義務人之子女，合於下列條件之一者，每年每人得減除其扶養親屬免稅額。 "
                        ),
                        _c("ul", { staticClass: "subtitle" }, [
                          _c("li", [_vm._v("(1) 未成年；")]),
                          _c("li", [
                            _vm._v("(2) 已成年，因在校就學受納稅義務人扶養；"),
                          ]),
                          _c("li", [
                            _vm._v("(3) 已成年，因身心障礙受納稅義務人扶養；"),
                          ]),
                          _c("li", [
                            _vm._v(
                              "(4) 已成年，因無謀生能力受納稅義務人扶養；"
                            ),
                          ]),
                          _c("li", [
                            _vm._v(
                              " 本人之子女合於上列規定條件者，計有 " +
                                _vm._s(
                                  _vm.incomeTax.Children
                                    ? _vm.incomeTax.Children.length
                                    : 0
                                ) +
                                " 人 "
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { "min-width": "100%" },
                              attrs: {
                                data: _vm.incomeTax.Children,
                                border: "",
                              },
                            },
                            [
                              _vm.incomeTax.Children &&
                              _vm.incomeTax.Children.length > 0
                                ? _c("el-table-column", {
                                    attrs: { width: "42" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("eva-icon", {
                                                attrs: {
                                                  name: "minus-square-outline",
                                                  fill: "#606266",
                                                  width: "20",
                                                  height: "20",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delRow(
                                                      "children",
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _c(
                                "el-table-column",
                                {
                                  attrs: { width: "220" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("ValidationProvider", {
                                              staticClass: "w-100",
                                              attrs: {
                                                name: `姓名+children+${scope.$index}`,
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("el-input", {
                                                          model: {
                                                            value:
                                                              scope.row.Name,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "Name",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.Name",
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "header" },
                                    [
                                      _vm._v(" 姓名 "),
                                      _c("eva-icon", {
                                        attrs: {
                                          name: "plus-square-outline",
                                          fill: "#606266",
                                          width: "20",
                                          height: "20",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRow("children")
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c("el-table-column", {
                                attrs: { label: "稱謂", width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `稱謂+children+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .Relationship,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "Relationship",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.Relationship",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "出生年月日", width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `出生年月日+children+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-date-picker", {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          type: "date",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          "picker-options": {
                                                            disabledDate:
                                                              _vm.$common
                                                                .disabledDateAfterToday,
                                                          },
                                                          placeholder:
                                                            "YYYY-MM-DD",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.Birthday,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "Birthday",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.Birthday",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "國民身分證統一編號或統一證號",
                                  width: "300",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `國民身分證統一編號或統一證號+children+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-input", {
                                                        model: {
                                                          value: scope.row.IdNo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "IdNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.IdNo",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "符合之條件" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `符合之條件+children+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.Type,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "Type",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.Type",
                                                          },
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "直系尊親屬滿60",
                                                              value: 1,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "直系尊親屬未滿60",
                                                              value: 2,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女未成年",
                                                              value: 3,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年在學",
                                                              value: 4,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年身心障礙",
                                                              value: 5,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年無謀生能力",
                                                              value: 6,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹未成年",
                                                              value: 7,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年在學",
                                                              value: 8,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年身心障礙",
                                                              value: 9,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年無謀生能力",
                                                              value: 10,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬未成年",
                                                              value: 11,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年在學",
                                                              value: 12,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年身心障礙",
                                                              value: 13,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年無謀生能力",
                                                              value: 14,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("li", [
                        _vm._v(
                          " 依法得稅法第 17 條規定，納稅義務人及其配偶之同胞兄弟姊妹，合於下列條件之一者，每年每人得減除其扶養親屬免稅額。 "
                        ),
                        _c("ul", { staticClass: "subtitle" }, [
                          _c("li", [_vm._v("(1) 未成年；")]),
                          _c("li", [
                            _vm._v("(2) 已成年，因在校就學受納稅義務人扶養；"),
                          ]),
                          _c("li", [
                            _vm._v("(3) 已成年，因身心障礙受納稅義務人扶養；"),
                          ]),
                          _c("li", [
                            _vm._v(
                              "(4) 已成年，因無謀生能力受納稅義務人扶養；"
                            ),
                          ]),
                          _c("li", [
                            _vm._v(
                              " 本人及其配偶之同胞兄弟姊妹合於上列規定條件者，計有 " +
                                _vm._s(
                                  _vm.incomeTax.Siblings
                                    ? _vm.incomeTax.Siblings.length
                                    : 0
                                ) +
                                " 人 "
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { "min-width": "100%" },
                              attrs: {
                                data: _vm.incomeTax.Siblings,
                                border: "",
                              },
                            },
                            [
                              _vm.incomeTax.Siblings &&
                              _vm.incomeTax.Siblings.length > 0
                                ? _c("el-table-column", {
                                    attrs: { width: "42" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("eva-icon", {
                                                attrs: {
                                                  name: "minus-square-outline",
                                                  fill: "#606266",
                                                  width: "20",
                                                  height: "20",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delRow(
                                                      "siblings",
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _c(
                                "el-table-column",
                                {
                                  attrs: { width: "220" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("ValidationProvider", {
                                              staticClass: "w-100",
                                              attrs: {
                                                name: `姓名+siblings+${scope.$index}`,
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("el-input", {
                                                          model: {
                                                            value:
                                                              scope.row.Name,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "Name",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.Name",
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "header" },
                                    [
                                      _vm._v(" 姓名 "),
                                      _c("eva-icon", {
                                        attrs: {
                                          name: "plus-square-outline",
                                          fill: "#606266",
                                          width: "20",
                                          height: "20",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRow("siblings")
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c("el-table-column", {
                                attrs: { label: "稱謂", width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `稱謂+siblings+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .Relationship,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "Relationship",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.Relationship",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "出生年月日", width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `出生年月日+siblings+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-date-picker", {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          type: "date",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          "picker-options": {
                                                            disabledDate:
                                                              _vm.$common
                                                                .disabledDateAfterToday,
                                                          },
                                                          placeholder:
                                                            "YYYY-MM-DD",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.Birthday,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "Birthday",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.Birthday",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "國民身分證統一編號或統一證號",
                                  width: "300",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `國民身分證統一編號或統一證號+siblings+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-input", {
                                                        model: {
                                                          value: scope.row.IdNo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "IdNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.IdNo",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "符合之條件" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `符合之條件+siblings+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.Type,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "Type",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.Type",
                                                          },
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "直系尊親屬滿60",
                                                              value: 1,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "直系尊親屬未滿60",
                                                              value: 2,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女未成年",
                                                              value: 3,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年在學",
                                                              value: 4,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年身心障礙",
                                                              value: 5,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年無謀生能力",
                                                              value: 6,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹未成年",
                                                              value: 7,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年在學",
                                                              value: 8,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年身心障礙",
                                                              value: 9,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年無謀生能力",
                                                              value: 10,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬未成年",
                                                              value: 11,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年在學",
                                                              value: 12,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年身心障礙",
                                                              value: 13,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年無謀生能力",
                                                              value: 14,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("li", [
                        _vm._v(
                          " 依法得稅法第17條規定，納稅義務人其他親屬或家屬，合於民法 1114 條第 4 款及第 1123 條第 3 項規定，且合於下列條件之一者，每年每人得減除其扶養親屬免稅額。 "
                        ),
                        _c("ul", { staticClass: "subtitle" }, [
                          _c("li", [_vm._v("(1) 未成年；")]),
                          _c("li", [
                            _vm._v("(2) 已成年，因在校就學受納稅義務人扶養；"),
                          ]),
                          _c("li", [
                            _vm._v("(3) 已成年，因身心障礙受納稅義務人扶養；"),
                          ]),
                          _c("li", [
                            _vm._v(
                              "(4) 已成年，因無謀生能力受納稅義務人扶養；"
                            ),
                          ]),
                          _c("li", [
                            _vm._v(
                              " 本人之其他親屬或家屬合於上列規定條件者，計有 " +
                                _vm._s(
                                  _vm.incomeTax.Others
                                    ? _vm.incomeTax.Others.length
                                    : 0
                                ) +
                                " 人 "
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { "min-width": "100%" },
                              attrs: { data: _vm.incomeTax.Others, border: "" },
                            },
                            [
                              _vm.incomeTax.Others &&
                              _vm.incomeTax.Others.length > 0
                                ? _c("el-table-column", {
                                    attrs: { width: "42" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("eva-icon", {
                                                attrs: {
                                                  name: "minus-square-outline",
                                                  fill: "#606266",
                                                  width: "20",
                                                  height: "20",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delRow(
                                                      "others",
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _c(
                                "el-table-column",
                                {
                                  attrs: { width: "220" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("ValidationProvider", {
                                              staticClass: "w-100",
                                              attrs: {
                                                name: `姓名+others+${scope.$index}`,
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("el-input", {
                                                          model: {
                                                            value:
                                                              scope.row.Name,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "Name",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.Name",
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "header" },
                                    [
                                      _vm._v(" 姓名 "),
                                      _c("eva-icon", {
                                        attrs: {
                                          name: "plus-square-outline",
                                          fill: "#606266",
                                          width: "20",
                                          height: "20",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRow("others")
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c("el-table-column", {
                                attrs: { label: "稱謂", width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `稱謂+others+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .Relationship,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "Relationship",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.Relationship",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "出生年月日", width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `出生年月日+others+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-date-picker", {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          type: "date",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          "picker-options": {
                                                            disabledDate:
                                                              _vm.$common
                                                                .disabledDateAfterToday,
                                                          },
                                                          placeholder:
                                                            "YYYY-MM-DD",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.Birthday,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "Birthday",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.Birthday",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "國民身分證統一編號或統一證號",
                                  width: "300",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `國民身分證統一編號或統一證號+others+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-input", {
                                                        model: {
                                                          value: scope.row.IdNo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "IdNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.IdNo",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "符合之條件" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: `符合之條件+others+${scope.$index}`,
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.Type,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "Type",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.Type",
                                                          },
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "直系尊親屬滿60",
                                                              value: 1,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "直系尊親屬未滿60",
                                                              value: 2,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女未成年",
                                                              value: 3,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年在學",
                                                              value: 4,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年身心障礙",
                                                              value: 5,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "子女已成年無謀生能力",
                                                              value: 6,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹未成年",
                                                              value: 7,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年在學",
                                                              value: 8,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年身心障礙",
                                                              value: 9,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "兄弟姊妹已成年無謀生能力",
                                                              value: 10,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬未成年",
                                                              value: 11,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年在學",
                                                              value: 12,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年身心障礙",
                                                              value: 13,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "其他親屬已成年無謀生能力",
                                                              value: 14,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        " 附註：民法 1114 條：左列親屬，互負扶養之義務： "
                      ),
                      _c(
                        "ul",
                        {
                          staticClass: "subtitle",
                          staticStyle: { "text-indent": "30px" },
                        },
                        [
                          _c("li", [_vm._v("一、 直系血親相互間。")]),
                          _c("li", [
                            _vm._v(
                              "二、 夫妻之一方與他方之父母同居者，其相互間。"
                            ),
                          ]),
                          _c("li", [_vm._v("三、 兄弟姊妹相互間。")]),
                          _c("li", [_vm._v("四、 家長家屬相互間。")]),
                        ]
                      ),
                      _c("ul", { staticClass: "ul-unstyled" }, [
                        _c(
                          "li",
                          {
                            staticStyle: {
                              "list-style": "none",
                              "text-indent": "48px",
                            },
                          },
                          [_vm._v(" 民法 1123 條：家置家長。 ")]
                        ),
                      ]),
                      _c(
                        "ul",
                        {
                          staticClass: "subtitle",
                          staticStyle: { "text-indent": "30px" },
                        },
                        [
                          _c("li", [_vm._v("同家之人，除家長外，均為家屬。")]),
                          _c("li", [
                            _vm._v(
                              "雖非親屬，而以永久共同生活為目的的同居一家者，視為家屬。"
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("table", { staticClass: "w-100" }, [
                      _c("thead", [_c("th")]),
                      _c("tr", [
                        _c("td", [_vm._v("薪資受領人")]),
                        _c("td", [
                          _vm._v(" " + _vm._s(_vm.incomeTax.Name) + " "),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticStyle: { width: "10%" } }, [
                          _vm._v("填報日期"),
                        ]),
                        _c("td", { staticStyle: { width: "40%" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.incomeTax.SignedTime
                                  ? _vm.$common.dateFormatter(
                                      _vm.incomeTax.SignedTime
                                    )
                                  : _vm.$common.getToday()
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("薪資受領人(簽章)")]),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.incomeTax.SignedPicBase64,
                                expression: "incomeTax.SignedPicBase64",
                              },
                            ],
                            attrs: { colspan: "3" },
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "400px",
                                height: "200px",
                                border: "1px solid #efefef",
                              },
                              attrs: {
                                src: _vm.incomeTax.SignedPicBase64,
                                alt: "",
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: { click: _vm.resigned },
                              },
                              [_vm._v("重簽")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.incomeTax.SignedPicBase64,
                                expression: "!incomeTax.SignedPicBase64",
                              },
                            ],
                            attrs: { colspan: "3" },
                          },
                          [
                            _c("VueSignature", {
                              ref: "signature",
                              staticStyle: { border: "1px solid #efefef" },
                              attrs: {
                                defaultUrl: _vm.incomeTax.SignedPicBase64 || "",
                                w: "400px",
                                h: "200px",
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: { click: _vm.clear },
                              },
                              [_vm._v("清除")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "mt-2",
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.downloadPDF },
                          },
                          [_vm._v(" 下載 PDF ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "mt-2 save-btn",
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return handleSubmit(_vm.saveIncomeTax)
                              },
                            },
                          },
                          [_vm._v(" 儲存 ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }